@if (authUserService.isTeacher()) {
  <app-confirm-dialog-teacher> </app-confirm-dialog-teacher>
} @else {
  <app-confirm-dialog-student></app-confirm-dialog-student>
}
